const LeadReportActionTypes = {
	FETCH_LEAD_LIST_START: 'fetch_lead_list_start',
	FETCH_LEAD_LIST_SUCCESS: 'fetch_lead_list_success',
	FETCH_LEAD_LIST_FAILURE: 'fetch_lead_list_failure',
	FETCH_LEAD_LIST_RESET_START: 'fetch_lead_list_reset_start',
	FETCH_LEAD_LIST_CHANGED: 'fetch_lead_list_changed',

	FETCH_OFFICER_LIST_START: 'fetch_officer_list_start',
	FETCH_OFFICER_LIST_SUCCESS: 'fetch_officer_list_success',
	FETCH_OFFICER_LIST_FAILURE: 'fetch_officer_list_failure',
	FETCH_OFFICER_LIST_RESET_START: 'fetch_officer_list_reset_start',
	FETCH_OFFICER_LIST_CHANGED: 'fetch_officer_list_changed',

	/**************** FETCH LEAD REPORT EXCEL START ********************** */
	FETCH_LEAD_CARD_EXCEL_START: 'FETCH_LEAD_CARD_EXCEL_START',
	FETCH_LEAD_CARD_EXCEL_SUCCESS: 'FETCH_LEAD_CARD_EXCEL_SUCCESS',
	FETCH_LEAD_CARD_EXCEL_FAILURE: 'FETCH_LEAD_CARD_EXCEL_FAILURE',
	FETCH_LEAD_CARD_EXCEL_RESET: 'FETCH_LEAD_CARD_EXCEL_RESET',
	FETCH_LEAD_CARD_EXCEL_CHANGED: 'FETCH_LEAD_CARD_EXCEL_CHANGED',
	/**************** FETCH LEAD REPORT EXCEL END ******************* */
};
export default LeadReportActionTypes;
